import * as types from './actionTypes';
import { myCarsInitialState } from './initialState';

/**
 * My Cars Reducer
 */

export const myCarsReducer = (state = myCarsInitialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_MY_CARS_REQUEST_COMPLETE: {
      const { myCarsAPIStatus, myCarsResponse } = payload;
      return {
        ...state,
        myCarsAPIStatus,
        cars: myCarsResponse,
      };
    }

    case types.SET_LOAN_DETAILS_INPROGRESS: {
      return {
        ...state,
        ...payload,
      };
    }

    case types.SET_LOAN_DETAILS: {
      const { cars } = state;
      const { isLoanDetailsComplete, vehicleId, loanDetails } = payload;
      const updatedCarsObject: any = cars.map((carItem: any) => {
        if (carItem.vehicle.vehicleId === Number(vehicleId)) {
          carItem.loanDetails = loanDetails;
          carItem.isLoanDetailsComplete = isLoanDetailsComplete;
          return carItem;
        }
        return carItem;
      });
      return {
        ...state,
        isLoanDetailsComplete,
        cars: updatedCarsObject,
      };
    }

    case types.SET_TRANSACTION_HISTORY_DETAILS: {
      const { cars } = state;
      const {
        isTransactionHistoryComplete,
        transactionHistory,
        vehicleId,
      } = payload;
      const updatedCarsObject: any = cars.map((carItem: any) => {
        if (carItem.vehicle.vehicleId === Number(vehicleId)) {
          carItem.transactionHistory = transactionHistory;
          carItem.isTransactionHistoryComplete = isTransactionHistoryComplete;
          return carItem;
        }
        return carItem;
      });

      return {
        ...state,
        isTransactionHistoryComplete,
        cars: updatedCarsObject,
      };
    }

    case types.SET_BANK_DETAILS: {
      const { cars } = state;
      const { isBankDetailsComplete, vehicleId, bankInfo } = payload;
      const updatedCarsObject: any = cars.map((carItem: any) => {
        if (carItem.vehicle.vehicleId === Number(vehicleId)) {
          carItem.bankInfo = bankInfo;
          carItem.isBankDetailsComplete = isBankDetailsComplete;
          return carItem;
        }
        return carItem;
      });

      return {
        ...state,
        isBankDetailsComplete,
        cars: updatedCarsObject,
      };
    }

    case types.SET_LOAN_AND_BANK_DETAILS: {
      const { cars } = state;
      const {
        isLoanDetailsComplete,
        vehicleId,
        loanDetails,
        bankInfo,
      } = payload;
      const updatedCarsObject: any = cars.map((carItem: any) => {
        if (carItem.vehicle.vehicleId === Number(vehicleId)) {
          carItem.loanDetails = loanDetails;
          carItem.bankInfo = bankInfo;
          return carItem;
        }
        return carItem;
      });

      return {
        ...state,
        isLoanDetailsComplete,
        cars: updatedCarsObject,
      };
    }
    case types.SET_MY_CARS:
      return {
        ...state,
        cars: payload,
      };
    case types.SET_CURRENT_VEHICLE: {
      return {
        ...state,
        currentVehicle: payload,
      };
    }
    case types.SET_CONTACT_DETAILS: {
      const { isContactDetailsComplete, contactDetails } = payload;
      return {
        ...state,
        isContactDetailsComplete,
        contactDetails,
      };
    }
    case types.SET_ONE_TIME_PAYMENT_DETAILS: {
      const { cars } = state;
      const { vehicleId } = payload;
      const updatedCarsObject: any = cars.map((carItem: any) => {
        if (carItem.vehicle.vehicleId === +vehicleId) {
          carItem.oneTimePaymentDetails = payload;
          return carItem;
        }
        return carItem;
      });
      return {
        ...state,
        cars: updatedCarsObject,
      };
    }
    default: {
      return state;
    }
  }
};
